import React, { ReactNode } from 'react';
import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ActionMeta } from 'react-select';
import { ComboboxOptions } from '../../../visual-components/combobox/types';
import { SearchParam } from '../../../core/routing/param';
import { Combobox } from '../../../visual-components/combobox/combobox';
import { GridItem } from '../../../visual-components/grid/grid';

export type TrackOnChange = (newValue: ComboboxOptions, meta: ActionMeta<ComboboxOptions[number]>) => void;

type Props = {
  label: string;
  values: string[] | ComboboxOptions | undefined;
  options: string[] | ComboboxOptions | undefined;
  query: SearchParam;
  trackOnChange?: TrackOnChange;
};

const GridFilterContent: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <GridItem span="3" spanMobile="4" spanTablet="2">
      {children}
    </GridItem>
  );
};

export const SimpleCombobox: React.FC<Props> = ({ label, values, options, query, trackOnChange }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  return (
    <GridFilterContent>
      <Combobox
        isMulti
        label={label}
        noOptionsFoundText={t('global.noResultsFound')}
        placeHolderText={t('global.chooseOption')}
        value={values?.map((title) => (typeof title === 'string' ? { value: title, label: title } : title))}
        options={
          options?.map((title) =>
            typeof title === 'string'
              ? {
                  value: title,
                  label: title,
                }
              : title,
          ) ?? []
        }
        onChange={(value, meta) => {
          const clonedSearchParams = new URLSearchParams(searchParams);
          clonedSearchParams.delete(query);
          clonedSearchParams.delete(SearchParam.page);
          value.forEach((v) => {
            clonedSearchParams.append(query, v.value);
          });
          setSearchParams(clonedSearchParams);
          trackOnChange?.(value, meta);
        }}
      />
    </GridFilterContent>
  );
};
